import { useState, useCallback, useEffect } from 'react';
import { formatearHora, horasAMinutos } from '../helpers/functionHelpers';

const useDisponibilidad = (duracion, horariosOcupados) => {
  const [disponibilidad, setDisponibilidad] = useState([]);

  const generarDisponibilidad = useCallback(() => {
    if (!duracion || duracion === 'Seleccione') {
      setDisponibilidad([]);
      return;
    }

    const slots = [];
    const startHour = 8;
    const endHour = 15;
    const stepMinutes = 15;

    let durationInMinutes;
    switch (duracion) {
      case '15 minutos': durationInMinutes = 15; break;
      case '30 minutos': durationInMinutes = 30; break;
      case '45 minutos': durationInMinutes = 45; break;
      case '1 hora': durationInMinutes = 60; break;
      case '1.5 horas': durationInMinutes = 90; break;
      case '2 horas': durationInMinutes = 120; break;
      case '2.5 horas': durationInMinutes = 150; break;
      case '3 horas': durationInMinutes = 180; break;
      case '4 horas': durationInMinutes = 240; break;
      default: durationInMinutes = 15;
    }

    const endTime = endHour * 60;

    const hOMinutos = horariosOcupados.map((horario) => ({
      inicio: horasAMinutos(formatearHora(horario.inicio)),
      fin: horasAMinutos(formatearHora(horario.fin)),
    }));

    for (let i = startHour * 60; i < endTime; i += stepMinutes) {
      const startTime = i;
      const endTimeSlot = startTime + durationInMinutes;

      const estaOcupado = hOMinutos.some(
        (ocupado) =>
          (startTime < ocupado.fin && endTimeSlot > ocupado.inicio)
      );

      if (!estaOcupado) {
        const startHourFormatted = `${Math.floor(startTime / 60)
          .toString()
          .padStart(2, '0')}:${(startTime % 60).toString().padStart(2, '0')}`;
        const endHourFormatted = `${Math.floor(endTimeSlot / 60)
          .toString()
          .padStart(2, '0')}:${(endTimeSlot % 60).toString().padStart(2, '0')}`;

        slots.push(`${startHourFormatted} - ${endHourFormatted}`);
      }
    }

    setDisponibilidad(slots);
  }, [duracion, horariosOcupados]);

  // 👇 Autoejecutar cuando cambian duración o horarios ocupados
  useEffect(() => {
    generarDisponibilidad();
  }, [generarDisponibilidad]);

  return { disponibilidad, generarDisponibilidad };
};

export default useDisponibilidad;
